import React from "react";
import PillIndicator from "@common/PillIndicator/PillIndicator";

interface HostPillIndicatorProps {
    readonly className?: string;
}
export default function HostPillIndicator(props: HostPillIndicatorProps) {
    return <PillIndicator className={props.className} label={"Host"} color={"purple"} />;
}
